import React, { useMemo } from 'react';

import { Marker as ReactLeafletMarker, Circle } from 'react-leaflet';
import { DivIcon } from 'leaflet';
import clsx from 'clsx';

import { usePosition } from './location-marker.hooks';

import classes from './location-marker.module.scss';

const markerSize = 20;

export const LocationMarker = () => {
  const { position, formattedCoordinates } = usePosition();

  const icon = useMemo(() => {
    return new DivIcon({
      html: `<div class="${classes.marker}"></div>`,
      iconSize: [markerSize, markerSize],
      iconAnchor: [markerSize / 2, markerSize / 2],
      className: clsx(classes.divIcon, classes.smoothTransition),
    });
  }, []);

  if (!position || !formattedCoordinates) return null;

  return (
    <>
      <Circle
        className={classes.smoothTransition}
        center={formattedCoordinates}
        stroke={false}
        radius={position.coords.accuracy}
      />
      <ReactLeafletMarker icon={icon} position={formattedCoordinates} />
    </>
  );
};
